import gsap from "gsap";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import DefaultBlock from "/scripts/default/block";
import { SplitText } from "gsap/SplitText";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

gsap.registerPlugin(MorphSVGPlugin, SplitText, MotionPathPlugin);

export default class SvgMorph extends DefaultBlock {
	init() {
		// Elements
		const el = {
			morphParent: this.block.querySelector("#svg-morph-flair"),
			saveTimePath: this.block.querySelector("#svg-morph-save-time--path"),
			heavyLiftingPath: this.block.querySelector(
				"#svg-morph-heavy-lifting--path"
			),
			saveTimeText: this.block.querySelector(".svg-morph__text--save-time"),
			heavyLiftingText: this.block.querySelector(
				".svg-morph__text--heavy-lifting"
			),
			saveTimeElements: this.block.querySelectorAll(
				"#svg-morph-save-time-points .svg-morph-point"
			),
			heavyLiftingElements: this.block.querySelectorAll(
				"#svg-morph-heavy-lifting-points .svg-morph-point"
			),
			pointsElements: this.block.querySelectorAll(
				"#svg-morph-points .svg-morph-point"
			),
			saveTimeTextSplit: null,
			heavyLiftingTextSplit: null,
		};
		this.el = el;

		// Positions state
		this.positions = [];

		this.initMorph();
	}

	splitMorphText() {
		this.el.saveTimeTextSplit = new SplitText(this.el.saveTimeText, {
			type: "words",
		});

		this.el.heavyLiftingTextSplit = new SplitText(this.el.heavyLiftingText, {
			type: "words",
		});

		gsap.set(this.el.heavyLiftingTextSplit.words, {
			y: 180,
		});
	}

	calculatePositions() {
		this.el.saveTimeElements.forEach((element, i) => {
			// Get opposite element
			const relativeElement = this.el.heavyLiftingElements[i];

			// Calculate positioning
			this.positions[i] = MotionPathPlugin.getRelativePosition(
				element,
				relativeElement,
				[0.5, 0.5],
				[0.5, 0.5]
			);
		});
	}

	morphAnimation() {
		const tl = gsap.timeline({
			repeat: -1,
			repeatDelay: 1,
			yoyo: true,
			defaults: {
				duration: 1,
				ease: "back.inOut(1.1)",
			},
		});

		watchPreferredMotion(() => {
			tl.to(
				this.el.saveTimeTextSplit.words,
				{
					y: 180,
				},
				0
			);

			tl.to(
				this.el.heavyLiftingTextSplit.words,
				{
					y: 0,
				},
				0
			);

			this.el.saveTimeElements.forEach((element, i) => {
				tl.to(
					element,
					{
						x: this.positions[i].x,
						y: this.positions[i].y,
						duration: 0.75,
					},
					0
				);
			});

			tl.to(
				this.el.saveTimePath,
				{
					ease: "power2.inOut",
					duration: 0.75,
					morphSVG: {
						shape: this.el.heavyLiftingPath,
						type: "rotational",
					},
				},
				0
			);

			tl.to(
				this.el.morphParent,
				{
					duration: 0.75,
					rotate: -90,
				},
				0
			);
		});

		return tl;
	}

	initMorph() {
		this.splitMorphText();
		this.calculatePositions();
		this.morphAnimation();

		window.addEventListener("resize", this.calculatePositions.bind(this));
	}
}
